<template>
    <div style="margin-left: 1rem; margin-right: 1rem; padding-top: 2rem; padding-bottom: 2rem;">
      <p style="text-align: center"><span  style="font-size:  18px;"><strong>墨计实名认证协议</strong></span></p>
      <p class="offset normal">
        为了保证您更好的使用广州墨斗信息科技有限公司（以下简称“墨斗科技”或“我们”）所属的墨计产品为您提供的实名认证服务（以下简称“本服务”），请您先仔细阅读本协议内容，尤其是字体加粗部分。
        如您对本协议内容或页面提示信息有疑问，请勿进行下一步操作，您可通过在线客服或服务电话020-39262944进行咨询，以便我们为您解释和说明。
        如果您在页面点击确认或以我们认可的其他方式确认本协议，即表示您已充分阅读、理解并同意本协议。
      </p>
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>1. 定义</strong></span></span></p>
      <p class="normal">实名认证：指墨计提供的，通过人脸比对、活体校验、证件比对等方式确认您身份的真实性，并将认证结果反馈给您所加入的实名制考勤企业。
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>2. 授权与许可</strong></span></span></p>
      <p class="normal">&bull;  2.1 为了向您提供认证服务的需要，您所加入的实名制考勤企业（以下简称“企业”）需要将您在申请加入企业过程中所提供或留存的信息（例如：姓名、身份证号码、手机号码）给墨计。</p>
      <p class="normal">&bull;  2.2 为了准确核验您的身份，尽量防止您的身份被冒用，您授权墨计收集您的人脸照片、证件照片信息，信息收集范围以认证服务页面具体提示为准。</p>
      <p class="normal">&bull;  2.3 为准确验证您的身份，针对前款载明的信息，墨计需要与合法存有您信息的第三方机构进行比对核验，以便核验您的身份真实性。</p>
      <p class="normal">&bull;  2.4 为便于企业进行员工实名制考勤管理，若您授权您申请加入或已经加入的企业调取墨计的认证结果、认证相关信息，则墨计将会按您的授权将其提供给企业。授权范围以本服务页面具体提示为准。</p>
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>3. 您的权利义务</strong></span></span></p>
      <p class="normal">&bull;  3.1 墨计会尽力提升核验结果的准确性。但由于信息范围有限，以及行业技术水平及核验手段仍在完善过程中，墨计无法确保核验结果的准确性。如您发现核验结果不准确，您可通过客服电话告知墨计，以便我们重新核验并逐步提升核验能力。</p>
      <p class="normal">&bull;  3.2 目前墨计就本服务不收取任何服务费；如后续本服务需要收费，墨计将通过公告或客户端通知等形式告知您收费时间及收费标准。</p>
      <p class="normal">&bull;  3.3 您不得将本服务用于中国法律法规所限制或禁止，以及违背道德风俗的领域，否则因此导致墨斗科技或第三方遭受损失的，您应承担相应赔偿责任。</p>
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>4. 墨计的权利义务</strong></span></span></p>
      <p class="normal">&bull;  4.1 墨斗科技应按本协议约定向您提供本服务。</p>
      <p class="normal">&bull;  4.2 墨计会根据认证技术的发展及市场风险环境的需要，不断调整完善本服务相应的内容及形式。</p>
      <p class="normal">&bull;  4.3 我们将依据《墨计隐私权政策》严格保护您的信息。请您仔细阅读该政策，如有任何疑问，请随时联系我们。</p>
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>5. 除外责任</strong></span></span></p>
      <p  class="normal">您理解并同意，鉴于计算机、互联网的特殊性，下述情况不属于墨计违约：</p>
      <p class="normal">1）因自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、网路堵塞、电信部门技术调整和政府管制等导致本服务不能提供或中断；</p>
      <p class="normal">2）黑客攻击造成服务中断、信息数据泄露；但我们将按照本协议约定做好应急处理；</p>
      <p class="normal">3）墨计在进行服务器配置、维护时，需要短时间中断服务；</p>
      <p class="normal">4）由于网络通路阻塞造成您网站访问速度下降；</p>
      <p class="normal">5）因国家法律法规及政策的相关要求，中断或终止本服务。</p>
      <p  style="line-height:  1.5;"><span  style="color:  rgb(51,  51,  51);"><span  style="font-size:  14px;"><br><strong>6. 其他</strong></span></span></p>
      <p class="normal">&bull;  6.1 为了向您提供更好的服务，我们将不时优化本服务，本协议的内容也可能随之更新，变更后的内容将于公布后生效。您可以随时在本软件的最新版本中查阅本协议，若您不同意变更后的协议内容，您有权停止使用本服务；双方协商一致的，也可另行变更相关服务和对应条款。</p>
      <p class="normal">&bull;  6.2 请您理解，为了满足您多样化的需求，向您提供更好的服务，您同意我们在经营策略调整时，可以将本协议下的部分或全部服务转交我们的关联主体运营或履行。在发生合并、分立、收购、资产转让时，我们也可向第三方转让本服务下的相关资产。</p>
      <p class="normal">&bull;  6.3 本协议适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区法律）。本协议项下纠纷，双方应努力友好协商解决，如协商不成，双方均可向被告住所地人民法院提起诉讼。</p>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: 'real_name',
};
</script>
<style scoped>
  p.offset {
    text-indent: 2em;
  }
  .normal {
    color:  rgb(102,  102,  102);
    font-size: 14px;
    line-height:  2
  }
</style>
